var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("ExcelConfig.Title"),
        visible: _vm.dialogVisible,
        width: "600px",
        "before-close": _vm.hide,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("p", [_vm._v(_vm._s(_vm.$t("ExcelConfig.Import")))]),
      _c(
        "div",
        { staticClass: "text" },
        [
          _vm._v(" 1." + _vm._s(_vm.$t("ExcelConfig.AfterDownload"))),
          _c("br"),
          _vm._v(" 2." + _vm._s(_vm.$t("ExcelConfig.ImportExcel")) + " "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onDownload } },
            [_vm._v(_vm._s(_vm.$t("ExcelConfig.Download")))]
          ),
          _c("br"),
          _vm._v(" 3." + _vm._s(_vm.$t("ExcelConfig.MustHave"))),
          _c("br"),
          _vm._v(" 4." + _vm._s(_vm.$t("ExcelConfig.Supports"))),
          _c("br"),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "BjImportFile",
            {
              ref: "BjImportFile",
              attrs: {
                accept: ".xls,.xlsx",
                "limit-size": 128 * 1024,
                "auto-upload": "",
              },
              on: { importFile: _vm.importFile },
              scopedSlots: _vm._u([
                {
                  key: "top",
                  fn: function () {
                    return undefined
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("template", { slot: "default" }, [
                _vm._v(" " + _vm._s(_vm.$t("ExcelConfig.maximum")) + " "),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("cancelText")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirm } },
            [_vm._v(_vm._s(_vm.$t("ExcelConfig.Confirm")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }